/**
 * Precio efectivo de una entrada.
 *
 * El backend expone el precio base en `precio` y el gasto de gestión en
 * `price_management`. Cuando el precio ya los incluye (`price_management_interno`)
 * no se vuelve a sumar. Misma regla que usaba la vista legacy de invitaciones,
 * centralizada acá para no repetirla en el composable y en la tabla de entradas.
 *
 * @param {object} ticket Entrada tal como la devuelve el pedido.
 * @returns {number} Precio con gastos de gestión incluidos.
 */
export function calcularPrecioEntrada(ticket) {
    let precio = parseFloat(ticket.precio);

    if (!ticket.price_management_interno) {
        precio = precio + parseFloat(ticket.price_management);
    }

    return precio;
}
